/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    if($(window).innerWidth() > 767) {
      position -= 90;
    }

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

var urlHash = location.hash;
if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
        var target = $(urlHash);
        var position = target.offset().top;

        if($(window).innerWidth() > 767) {
          position -= 90;
        }

        $('body,html').stop().animate({scrollTop:position}, 0);
    }, 100);
}


$(function(){
  $('.page-galModal').each(function(index, el) {
    const $root = $(this);
    const $slider = $root.find('.page-galModal__slick');
    const $thumbs = $root.find('.page-galModal__thumbs');
    let now = 0;

    $slider.find('img').each(function(index, el) {
      $thumbs.append($(this).clone());
    });

    $slider.slick({
      arrows: true,
      dots: false
    })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        let x = nextSlide * 144;

        if($(window).innerWidth() <= 767) {
          x = nextSlide * 61;
        }

        $thumbs.css('left', 'calc(50% - ' + x + 'px)');
      }
    });

    $('.page-gal__link').on('click', function(event) {
      now = parseInt($(this).attr('data-num') - 1);
    });

    $(document).on('opening', '.remodal', function () {
      $slider.slick('setPosition');
      $slider.slick('slickGoTo', now, true);

      bodyFix();
    });

    $(document).on('closing', '.remodal', function () {
      bodyFixReset();
    });

    setTimeout(function(){
      $('.remodal-wrapper').each(function(index, el) {
        $(this).append($(this).find('.page-galModal__thumbs'));
      });
    }, 100);

    $thumbs.find('img').each(function(index, el) {
      const i = index;

      $(this).on('click', function(event) {
        $slider.slick('slickGoTo', i);
      });
    });
  });
});


//以下、bodyを固定する関数
var bodyElm = $('body');
var scrollPosi;
var isBodyFixOpen = false;
function bodyFix(){
  if(!isBodyFixOpen) {
    isBodyFixOpen = true;

    scrollPosi = $(window).scrollTop();
    console.log(scrollPosi);
    bodyElm.css({
      'position': 'fixed',
      'width': '100%',
      'z-index': '1',
      'top': -scrollPosi
    });
  }
}

//以下、body固定を解除する関数
function bodyFixReset(){
  if(isBodyFixOpen) {
    isBodyFixOpen = false;

    bodyElm.removeAttr('style');

    //scroll位置を調整
    $('html, body').scrollTop(scrollPosi);
  }
}

$(function(){
  $('.home-kv').each(function(index, el) {
    const $kv = $(this);
    let isHide = false;

    $(window).on('scroll', function(event) {
      if($(window).scrollTop() > $kv.innerHeight() + 100) {
        if(!isHide) {
          isHide = true;
          $kv.addClass('is-hide');
        }
      } else {
        if(isHide) {
          isHide = false;
          $kv.removeClass('is-hide');
        }
      }
    });
  });
});

$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: false,
      autoplaySpeed: 4000,
      fade: true,
      speed: 2000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: true,
      swipe: false
    })
    .on({
      /*
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");

        setTimeout(function(){
          $('.home-kv__slideAniStart').trigger('click');
        }, 0);

        setTimeout(function(){
          $('.home-kv__slideAniStop').trigger('click');
        }, 1000);
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide slide-animation");
      }
      */
    });

    setTimeout(function(){
      $slider.slick("slickSetOption", "autoplay", true, true);
    }, 500);

    /*
    setTimeout(function(){
      $('.home-kv__slideAniStop').trigger('click');
    }, 1500);

    $slider.find(".slick-slide").eq(0).addClass("slide-animation");
    */
  });
});


/*
$(function(){
  $('.home-kv__slideAni').each(function(index, el) {
    const $slide = $(this);
    const $start = $('.home-kv__slideAniStart');

    const $ripple = new RippleEffect({
        parent: $slide.get(0),
        intensity: 1,
        strength: 0.5,
        area: 4,
        waveSpeed: 0.004,
        speedIn: 2,
        speedOut: 2.5,
        easing: 'Expo.easeInOut',
        hover: false,
        texture: $slide.attr('data-src'),
    });

    document.querySelector('.home-kv__slideAniStart').addEventListener('click', $ripple.start);
    document.querySelector('.home-kv__slideAniStop').addEventListener('click', $ripple.stop);

    setTimeout(function(){
      $('.home-kv__slideAniStart').trigger('click');
    }, 200);
  });

});
*/

$(function(){
  $('.l-header').each(function(index, el) {
    const $h = $(this);
    const $res = $('.home-res');
    const $footer = $('.l-footer');

    $(window).on('scroll', function(event) {
      run();
    });

    run();

    function run() {
      if($(window).scrollTop() > 200) {
        $h.addClass('is-sc');
      } else {
        $h.removeClass('is-sc');
      }

      if($(window).scrollTop() > 200
         && $(window).scrollTop() + $(window).innerHeight() < $footer.offset().top) {
        $res.addClass('is-sc');
      } else {
        $res.removeClass('is-sc');
      }
    }
  });
});

$(function(){
  $('.home-room__imgs').each(function(index, el) {
    const $imgs = $(this);
    const $img = $('.home-room__img');
    const $nav = $('.home-room__nav.-pc');
    const $navSP = $('.home-room__navSp');
    const $btn = $('.home-room__imgLink, .home-room__nav li a');
    const $cons = $('.home-room__cons');
    const $con = $('.home-room__con');
    const $btn2 = $('.home-room__btn');

    let now = 1;
    let now2 = 1;
    let timer;
    let conHMax = 0;

    $(window).on('resize', function(event) {
     setConH();
    });

    setConH();

    $(window).on('scroll', function(event) {
      if($(window).innerWidth() < 768 && $(window).scrollTop() > $nav.offset().top) {
        $navSP.addClass('is-fix');
      } else {
        $navSP.removeClass('is-fix');
      }

      if($(window).innerWidth() < 768 && $(window).scrollTop() > $btn2.offset().top - 59) {
        $navSP.addClass('is-fixHide');
      } else {
        $navSP.removeClass('is-fixHide');
      }
    });

    function setConH(){
      conHMax = 0;

      $con.each(function(index, el) {
        let style = $(this).attr('style');

        $(this).removeAttr('style')

        if(conHMax < $(this).innerHeight()) {
          conHMax = $(this).innerHeight();
        }

        $(this).attr('style', style);
      });

      $cons.css('height', conHMax);
    }

    timer = setInterval(function(){
      if(now == 1) {
        now2 ++;
        if(now2 > 3) now2 = 1;

        $img.removeClass('is-cr').filter('.-n1-' + now2).addClass('is-cr');
      }
    }, 3000);

    $btn.on('click', function(event) {
      let next = parseInt($(this).attr('data-n'));

      if(next != now) {
        now = next;
        run();
      }
    });

    function run() {
      $imgs.attr('data-sel', now);

      $img.removeClass('is-cr').filter('.-n' + now).addClass('is-cr');

      $btn.removeClass('is-cr').filter('[data-n="' + now + '"]').addClass('is-cr');
      $btn.removeClass('is-cr').filter('[data-n="' + now + '"]').addClass('is-cr');

      $con.stop().hide().filter('.-n' + now).fadeIn(1000);
    }
  });
});

$(function(){
  $('.home-spot__imgs').each(function(index, el) {
    const $imgs = $(this);
    const $img = $('.home-spot__img');

    let now = 1;
    let timer;

    timer = setInterval(function(){
      now ++;
      if(now > 3) now = 1;

      $img.removeClass('is-cr').filter('.-n' + now).addClass('is-cr');
    }, 3000);
  });
});


$(function(){
  $('.l-main').each(function(index, el) {
    const $main = $(this);
    const $rock = $('.home-rock p');

    $(window).on('scroll', function(event) {
      run();
    });

    function run(){
      let cal = 0;

      cal = $(window).scrollTop();

      cal = (cal % 1000 - 500) * (cal % 1000 - 500) / 4000;

      $rock.each(function(index, el) {
        const $t = $(this);

        $t.css({ transform: 'rotate(' + cal + 'deg)' })
      });
    }
  });
});

//fade
$(function(){
  var fade = $('.fade');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 100;
      var pointSc = winB;
      var pointD = 0;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.mouseHamon').each(function(index, el) {
    const $hamon = $(this);
    let timer;

    $(window).on('click', function(e) {
      clearTimeout(timer);

      $hamon.removeClass('is-ani');

      setTimeout(function(){
        $hamon.addClass('is-ani').css({
          left: e.clientX,
          top: e.clientY
        });;
      }, 10);

      timer = setTimeout(function(){
        $hamon.removeClass('is-ani');
      }, 1000);
    });
  });
});


const rippleSettings = {
  maxSize: 80,
  animationSpeed: 3,
  strokeColor: [255, 255, 255],
};

const canvasSettings = {
  blur: 4,
  ratio: 1,
};

function Coords(x, y) {
  this.x = x || null;
  this.y = y || null;
}

const Ripple = function Ripple(x, y, circleSize, ctx) {
  this.position = new Coords(x, y);
  this.circleSize = circleSize;
  this.maxSize = rippleSettings.maxSize;
  this.opacity = 1;
  this.ctx = ctx;
  this.strokeColor = `rgba(${Math.floor(rippleSettings.strokeColor[0])},
    ${Math.floor(rippleSettings.strokeColor[1])},
    ${Math.floor(rippleSettings.strokeColor[2])},
    ${this.opacity})`;

  this.animationSpeed = rippleSettings.animationSpeed;
  this.opacityStep = (this.animationSpeed / (this.maxSize - circleSize)) / 2;
};

Ripple.prototype = {
  update: function update() {
    this.circleSize = this.circleSize + this.animationSpeed;
    this.opacity = this.opacity - this.opacityStep;
    this.strokeColor = `rgba(${Math.floor(rippleSettings.strokeColor[0])},
      ${Math.floor(rippleSettings.strokeColor[1])},
      ${Math.floor(rippleSettings.strokeColor[2])},
      ${this.opacity})`;
  },
  draw: function draw() {
    this.ctx.beginPath();
    this.ctx.strokeStyle = this.strokeColor;
    this.ctx.arc(this.position.x, this.position.y, this.circleSize, 0,
      2 * Math.PI);
    this.ctx.stroke();
  },
  setStatus: function setStatus(status) {
    this.status = status;
  },
};

const canvas = document.querySelector('#mouseWater');
const ctx = canvas.getContext('2d');
const ripples = [];

const height = document.body.clientHeight;
const width = document.body.clientWidth;

const rippleStartStatus = 'start';

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

canvas.style.filter = `blur(${canvasSettings.blur}px)`;

canvas.width = width * canvasSettings.ratio;
canvas.height = height * canvasSettings.ratio;

canvas.style.width = `${width}px`;
canvas.style.height = `${height}px`;

let animationFrame;

// Add GUI settings
const addGuiSettings = () => {
  const gui = new dat.GUI();
  gui.add(rippleSettings, 'maxSize', 0, 1000).step(1);
  gui.add(rippleSettings, 'animationSpeed', 1, 30).step(1);
  gui.addColor(rippleSettings, 'strokeColor');

  const blur = gui.add(canvasSettings, 'blur', 0, 20).step(1);
  blur.onChange((value) => {
    canvas.style.filter = `blur(${value}px)`;
  });
};

//addGuiSettings();

// Function which is executed on mouse hover on canvas
const canvasMouseOver = (e) => {
  const x = e.clientX * canvasSettings.ratio;
  const y = e.clientY * canvasSettings.ratio;
  ripples.unshift(new Ripple(x, y, 2, ctx));
};

const animation = () => {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const length = ripples.length;
  for (let i = length - 1; i >= 0; i -= 1) {
    const r = ripples[i];

    r.update();
    r.draw();

    if (r.opacity <= 0) {
      ripples[i] = null;
      delete ripples[i];
      ripples.pop();
    }
  }
  animationFrame = window.requestAnimationFrame(animation);
};

animation();
document.body.addEventListener('mousemove', canvasMouseOver);
